export const environment = {
  production: true,
  // TODO durch prod URL ersetzen wenn der Onlinerechner in prod deployed wird.
  mpUrl: 'https://vpmerlindevlive/',
  piwikSiteKey: '#{piwikSiteKey}#'
};
